<template>
  <div v-if="checks.length" class="record-checks">
    <el-alert v-for="c in checks" :key="c.code + c.message" :type="c.level || 'warning'" show-icon
      @close="$store.commit('api/dismiss_record_check', c)">
      <template #title>
        <div class="record-checks-row">
          <span>{{ c.message }}</span>
          <span v-if="c.links && c.links.length" class="record-checks-links">
            <el-button v-for="l in c.links" :key="l.url" size="small" class="record-checks-link" @click="open(l.url)">
              {{ $t('common.open') }} {{ l.label }}
            </el-button>
          </span>
        </div>
      </template>
    </el-alert>
  </div>
</template>

<script>
// Messages of the backend record checks (development/record_checks.py) for the
// open record: non-blocking save warnings and checks run on opening it.
export default {
  name: "RecordChecks",
  computed: {
    checks() {
      return this.$store.state.api.record_checks || []
    }
  },
  methods: {
    // A new tab keeps the current record (and any unsaved edits) where it is.
    open(url) {
      window.open(this.$router.resolve(url).href, '_blank')
    }
  }
};
</script>

<style scoped>
.record-checks {
  padding: 6px 8px 0 8px;
}

.record-checks .el-alert {
  margin-bottom: 4px;
}

/* Let the title span the alert so the buttons can sit at its right edge. */
.record-checks :deep(.el-alert__content) {
  flex: 1;
  /* Keep the buttons clear of the absolutely placed close X. */
  padding-right: 24px;
}

/* Element pins the X 12px from the top; centre it on the alert instead. */
.record-checks :deep(.el-alert__closebtn) {
  top: 50%;
  transform: translateY(-50%);
}

.record-checks-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px 8px;
}

.record-checks-links {
  margin-left: auto;
}

.record-checks-link.el-button {
  height: 14px;
  padding: 0 6px;
  font-size: 11px;
  color: #6c6c6c;
  border-color: #e5c38f;
  background-color: #ffe3b8;
}

.record-checks-link.el-button:hover,
.record-checks-link.el-button:focus {
  color: #5b5b5b;
  border-color: #c5a370;
  background-color: #eacca1;
}
</style>
